import { useTools } from "./useTools";

const useAppInitialization = (): void => {
  useTools();
};

export default useAppInitialization;
